import { BuildingPeriodAccountingExpense, IncomingAccountingExpense } from '@app/models/accountingExpense';
import api from '@services/api';

export interface AccountingExpenseRequest {
  buildingId: number;
  period: string | undefined;
}

export const expenseApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getIncomingAccountingExpense: builder.query<Array<IncomingAccountingExpense>, AccountingExpenseRequest>({
      query: (input) => ({
        url: `/building/monthly-expense/byPeriodAndBuilding?period=${input.period}&buildingId=${input.buildingId}`,
        method: 'GET',
        validateStatus: (response) => response.status === 200 || response.status === 302,
      }),
      providesTags: ['Expense'],
    }),
    findAccountingExpensesByPeriodAndBuilding: builder.query<
      Array<BuildingPeriodAccountingExpense>,
      AccountingExpenseRequest
    >({
      query: (input) => ({
        url: `/building/monthly-expense/findAllPeriodAndBuilding?period=${input.period}&buildingId=${input.buildingId}`,
        method: 'GET',
        validateStatus: (response) => response.status === 200 || response.status === 302,
      }),
      providesTags: ['BuildingPeriodExpenses'],
    }),
    fetchIncomingAccountingExpense: builder.mutation<void, AccountingExpenseRequest>({
      query: (input: AccountingExpenseRequest) => ({
        url: `/building/monthly-expense/request`,
        method: 'POST',
        body: { buildingId: input.buildingId, period: input.period },
      }),
      invalidatesTags: ['Expense'],
    }),
    deleteAccountingExpenses: builder.mutation<void, number>({
      query: (id) => ({
        url: `/building/monthly-expense/delete?id=${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['BuildingPeriodExpenses'],
    }),
  }),
});

export const {
  useGetIncomingAccountingExpenseQuery,
  useFindAccountingExpensesByPeriodAndBuildingQuery,
  useFetchIncomingAccountingExpenseMutation,
  useDeleteAccountingExpensesMutation,
} = expenseApi;
